const COLORS = {
  primary: {
    // https://uicolors.app/create
    DEFAULT: "#01b9cc",
    30: "#ecffff",
    50: "#eefafa",
    100: "#cefeff",
    200: "#a3fafe",
    300: "#64f3fc",
    400: "#1de2f3",
    500: "#01b9cc",
    600: "#049cb6",
    700: "#0b7d93",
    800: "#136477",
    900: "#145365",
    950: "#073745",
  },
  grey: {
    DEFAULT: "#656464",
    100: "#f9fafb",
    200: "#eaecf0",
    300: "#bbbbbb",
    400: "#acacac",
    500: "#707070",
    800: "#333333",
  },
  red: {
    50: "#fef3f2",
    100: "#fee4e2",
    200: "#fecaca",
    400: "#f87171",
    600: "#dc2626",
  },
  white: "#ffffff",
  status: {
    ready: "#00c55a",
    active: "#00c55a",
    pause: "#ffba54",
    stop: "#ff635f",
    archived: "#e0e0e0",
    queued: "rgba(245, 158, 11, 1)",
    transcoding: "#2196f3",
    transcoded: "#00c55a",
    canceled: "#e0e0e0",
    error: "#ff635f",
    untranscoded: "dimgrey",
  },
} as const;

export default COLORS;
